module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/beaker.8b8d6bb0aa157319.gif";